<template>
  <v-container class="text-center fill-height d-flex flex-column justify-center align-center">
    <v-fade-transition leave-absolute>
      <div v-if="!assigning && !isFinished" key="start">
        <v-icon size="100" color="success">mdi-auto-fix</v-icon>
        <h1 class="text-h4 font-weight-bold my-4">Bereit für die Magie?</h1>
        <p class="text-h6 font-weight-light" style="max-width: 600px">
          Der Assistent wird nun den optimalen Einsatzplan erstellen. Dabei beachtet er alle von Ihnen in Schritt 2 festgelegten Regeln:
        </p>

        <v-row justify="center" class="mt-6">
          <v-col cols="12" md="10">
            <v-card outlined class="pa-4 rounded-lg">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold mb-2">Der Algorithmus prüft:</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-account-clock</v-icon>
                    Ausgleich von Über- & Minusstunden
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-calendar-check</v-icon>
                    Berücksichtigung von Ferien, Schultagen & fixen Abwesenheiten
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-gavel</v-icon>
                    Einhaltung der gesetzlichen Ruhezeiten (CH)
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-icon small color="primary" class="mr-2">mdi-scale-balance</v-icon>
                    Faire Verteilung von Wochenend- & Abendschichten
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-btn x-large color="success" class="mt-8" @click="startAssignment">
          <v-icon left>mdi-play-circle</v-icon>
          Plan jetzt automatisch erstellen
        </v-btn>
      </div>

      <div v-else-if="assigning" key="loading" class="d-flex flex-column align-center">
        <v-progress-circular :size="100" :width="8" color="primary" indeterminate></v-progress-circular>
        <h2 class="text-h5 font-weight-light mt-6">{{ currentStatus }}</h2>
        <p class="mt-2 grey--text">Dieser Vorgang kann einen Moment dauern...</p>
      </div>

      <div v-else-if="isFinished" key="done">
        <v-icon size="100" color="primary">mdi-check-decagram</v-icon>
        <h1 class="text-h4 font-weight-bold my-4">Einsatzplan erfolgreich erstellt!</h1>
        <p class="text-h6 font-weight-light">Der Plan wurde mit den zugewiesenen Mitarbeitern befüllt.</p>
        <v-btn x-large color="primary" class="mt-6" @click="$emit('view-plan')">
          <v-icon left>mdi-calendar-search</v-icon>
          Fertigen Plan ansehen
        </v-btn>
      </div>
    </v-fade-transition>
  </v-container>
</template>

<script>
import api from "@/api"

export default {
  name: "ShiftManagementAssignment",
  props: {
    studioId: { type: String, required: true },
    planningStartDate: { type: String, required: true },
    planningEndDate: { type: String, required: true },
  },
  data() {
    return {
      assigning: false,
      isFinished: false,
      currentStatus: "Initialisiere Planung...",
      statusInterval: null,
      statuses: [
        "Sammle Mitarbeiterdaten & Regeln...",
        "Prüfe Ferien & Abwesenheiten...",
        "Analysiere Schichtbedarf...",
        "Optimiere Stundensaldi...",
        "Stelle faire Verteilung sicher...",
        "Finalisiere Zuweisungen...",
      ],
    }
  },
  beforeDestroy() {
    clearInterval(this.statusInterval)
  },
  methods: {
    startAssignmentAnimation() {
      let index = 0
      this.currentStatus = this.statuses[index]
      this.statusInterval = setInterval(() => {
        index = (index + 1) % this.statuses.length
        this.currentStatus = this.statuses[index]
      }, 2500)
    },
    async startAssignment() {
      this.assigning = true
      this.isFinished = false
      this.startAssignmentAnimation()

      try {
        const updatedPlan = await api.shiftManagement.assignEmployeesToPlan(this.studioId, this.planningStartDate, this.planningEndDate)
        this.$emit("assignment-complete", updatedPlan)
        this.isFinished = true
      } catch (error) {
        this.$toast.error("Ein Fehler ist aufgetreten. Der Plan konnte nicht erstellt werden.")
        console.error(error)
        this.isFinished = false // Zurück zum Start-Zustand bei Fehler
      } finally {
        this.assigning = false
        clearInterval(this.statusInterval)
      }
    },
  },
}
</script>

<style scoped>
.container {
  background: #1e1e1e; /* Dunkler Hintergrund für Kontrast */
}
</style>
